// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-container .v-text-field__details {\n  display: none;\n}\n.login-container .logo {\n  width: 300px;\n}\n.login-container .error-message {\n  top: 130px;\n  left: 41px;\n  width: 500px;\n  text-align: center;\n}\n.login-container .error-message-row {\n  min-height: 2rem;\n}", ""]);
// Exports
module.exports = exports;
